import { useState } from "react";
import { faqs } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function FAQ() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="relative py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ 常见问题"
          title="你可能想知道的"
          desc="关于韩国动态漫画与榜单的常见疑问，帮你快速上手。"
        />

        <div className="space-y-3 md:space-y-4">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-colors ${
                  isOpen ? "border-accent-300 bg-accent-100/60" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 cursor-pointer text-left"
                >
                  <h3 className="text-sm md:text-base font-bold text-foreground-950 flex-1">{f.q}</h3>
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-transform ${
                      isOpen ? "rotate-45 bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>
                <div className={`faq-body ${isOpen ? "open" : ""}`}>
                  <div>
                    <p className="px-5 pb-5 text-sm text-foreground-700 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}